const Electrical = props => (
  <svg {...props} width="17px" height="16px" viewBox="0 0 17 16">
    <g id="FPCBuilder" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" transform="translate(-570.000000, -95.000000)">
      <g id="Electrical" transform="translate(571.000000, 96.000000)" stroke="#313F4C" strokeWidth="1.5">
        <path d="M14.0957919,5.5 L7.09579187,5.5" id="Line-6" strokeLinecap="square"></path>
        <path d="M14.0957919,8.5 L7.09579187,8.5" id="Line-6-Copy" strokeLinecap="square"></path>
        <circle id="Oval-Copy" cx="7.59579187" cy="7" r="7"></circle>
      </g>
    </g>
  </svg>
);

export default Electrical;
